import { Box } from "@mui/material";
import { useGetMondayMorningWrapUpQuery } from "app/containers/TeamsTab/teamsCheckInApi";
import { ScoreCard } from "../../layer20";
import { ConversationList, IssueList, UpcomingOneOnOneList } from "../../layer21";

export type DashboardActivityDetailSectionProps = {};

export const DashboardActivityDetailSection = () => {
  const { data: wrapUp, isLoading: wrapUpLoading } =
    useGetMondayMorningWrapUpQuery({});

  return (
    <Box
      display="flex"
      flexDirection="column"
      rowGap=".75rem"
      marginTop="1.5rem"
    >
      <IssueList />
      <ScoreCard
        reports={wrapUp?.reports ?? []}
        date={wrapUp?.date ?? ""}
        isLoading={wrapUpLoading}
      />
      <ConversationList />
      <UpcomingOneOnOneList />
    </Box>
  );
};
